import type { ApiClient } from "@quotientjs/core"
import type { Store } from "@/clients/store"

import { People } from "./people"

export class Audience {
  public people: People

  constructor(apiClient: ApiClient, store: Store) {
    this.people = new People(apiClient, store)
  }
}
